var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle62C = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 54 67",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M7 2.5A2.5 2.5 0 0 1 9.5 0h35A2.5 2.5 0 0 1 47 2.5v7a2.5 2.5 0 0 1-2.5 2.5h-35A2.5 2.5 0 0 1 7 9.5v-7ZM47 64.5a2.5 2.5 0 0 1-2.5 2.5h-35A2.5 2.5 0 0 1 7 64.5v-7A2.5 2.5 0 0 1 9.5 55h35a2.5 2.5 0 0 1 2.5 2.5v7ZM36.334 19.5a2.5 2.5 0 0 1 2.5-2.5H50.5a2.5 2.5 0 0 1 2.5 2.5v10a2.5 2.5 0 0 1-2.5 2.5H36.334V19.5ZM18.666 19.5a2.5 2.5 0 0 1 2.5-2.5h11.667a2.5 2.5 0 0 1 2.5 2.5V32H18.667V19.5ZM1 19.5A2.5 2.5 0 0 1 3.5 17h11.667a2.5 2.5 0 0 1 2.5 2.5V32H3.5A2.5 2.5 0 0 1 1 29.5v-10Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M53 21a1 1 0 0 1 1 1v7.5a3.5 3.5 0 0 1-3.5 3.5h-47A3.5 3.5 0 0 1 0 29.5V22a1 1 0 1 1 2 0v7.5A1.5 1.5 0 0 0 3.5 31h47a1.5 1.5 0 0 0 1.5-1.5V22a1 1 0 0 1 1-1Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M17.666 47.5a2.5 2.5 0 0 1-2.5 2.5H3.5A2.5 2.5 0 0 1 1 47.5v-10A2.5 2.5 0 0 1 3.5 35h14.166v12.5ZM35.334 47.5a2.5 2.5 0 0 1-2.5 2.5H21.166a2.5 2.5 0 0 1-2.5-2.5V35h16.666v12.5ZM53 47.5a2.5 2.5 0 0 1-2.5 2.5H38.833a2.5 2.5 0 0 1-2.5-2.5V35H50.5a2.5 2.5 0 0 1 2.5 2.5v10Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M1 46a1 1 0 0 1-1-1v-7.5A3.5 3.5 0 0 1 3.5 34h47a3.5 3.5 0 0 1 3.5 3.5V45a1 1 0 1 1-2 0v-7.5a1.5 1.5 0 0 0-1.5-1.5h-47A1.5 1.5 0 0 0 2 37.5V45a1 1 0 0 1-1 1Z",
  clipRule: "evenodd"
})));
SvgRectangle62C.viewBox = '0 0 54 67';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle62C);
export default ForwardRef;